'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CwTriggerField = require('../cwtriggerfield/CwTriggerField');

var _CwTriggerField2 = _interopRequireDefault(_CwTriggerField);

var _CwPillTriggerField = require('./CwPillTriggerField.scss');

var _CwPillTriggerField2 = _interopRequireDefault(_CwPillTriggerField);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwPillTriggerField = function (_React$Component) {
  (0, _inherits3.default)(CwPillTriggerField, _React$Component);

  function CwPillTriggerField(props) {
    (0, _classCallCheck3.default)(this, CwPillTriggerField);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CwPillTriggerField.__proto__ || (0, _getPrototypeOf2.default)(CwPillTriggerField)).call(this, props));

    _this.componentWillReceiveProps = function (nextProps) {
      if (nextProps.value === '') {
        _this.setState({ displayText: '' });
      }
    };

    _this.onChange = function (value) {
      _this.setState({ displayText: value });
      _this.props.onChange(value);
    };

    _this.state = {
      displayText: ''
    };
    return _this;
  }

  (0, _createClass3.default)(CwPillTriggerField, [{
    key: 'getParentDiv',
    value: function getParentDiv() {
      return this.parentDiv;
    }
  }, {
    key: 'getInputField',
    value: function getInputField() {
      return this.cwTriggerField.cwTextField.inputField;
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.cwTriggerField.cwTextField.focus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        {
          'data-cwid': this.props.cwId,
          className: this.props.style,
          ref: function ref(div) {
            return _this2.parentDiv = div;
          }
        },
        _react2.default.createElement(_CwTriggerField2.default, {
          cwId: this.props.cwId + '_trigger',
          className: _CwPillTriggerField2.default.cwPillTriggerFieldTriggerField,
          triggerIcon: this.props.triggerIcon,
          autoComplete: 'off',
          ref: function ref(input) {
            return _this2.cwTriggerField = input;
          },
          onFocus: this.props.onFocus,
          onBlur: this.props.onBlur,
          onChange: this.onChange,
          onKeyDown: this.props.onKeyDown,
          onKeyUp: this.props.onKeyUp,
          value: this.state.displayText,
          disabled: this.props.disabled,
          invalid: this.props.invalid,
          onTrigger: this.props.handleTriggerClick,
          customElement: this.props.pills,
          customElementClassName: _CwPillTriggerField2.default.cwPillTriggerFieldTriggerField,
          expandOnClick: this.props.expandOnClick
        }),
        this.props.children
      );
    }
  }]);
  return CwPillTriggerField;
}(_react2.default.Component);

CwPillTriggerField.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes2.default.string,
  /**
   * Represents the item that has been selected from the list (or string of custom item entered in if allowCustomEntry set to true). Returns an object {id,name} by default.
   */
  value: _propTypes2.default.any,
  /**
   * Callback function that is fired when combobox's selection changes
   */
  onChange: _propTypes2.default.func,
  /**
   * Used to control if combobox is valid
   */
  invalid: _propTypes2.default.bool,
  /**
   * Used to disable combobox
   */
  disabled: _propTypes2.default.bool,
  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: _propTypes2.default.func,
  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: _propTypes2.default.func,
  /**
   * True to expand dropdown when clicking on field, not just trigger
   */
  expandOnClick: _propTypes2.default.bool
};

CwPillTriggerField.defaultProps = {
  value: []
};

exports.default = CwPillTriggerField;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwpilltriggerfield/CwPillTriggerField.js
// module id = 846
// module chunks = 10